import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatIsoDate';
import { getAll as getAllReseauTempo } from '@/api/temporaire31/reseauView';
import { getAllPlanning } from '@/api/dispo/index';
import { ajoutLignesCommandeProduitReseauTempoFromPlanningReseauTempo } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauTempo';
import getLogo from '@/services/general/getLogo';
import affectationReseauTempo from '@/services/affectation/affectationReseauTempo';
import gestionFacesReelSurDispo from '@/services/catalogue/produitReseau/affectationFaceProduitReseau';
import { BLOQUE, OPTION } from '@/configuration/optionBlocage/optionBlocage';
import { get as getReseau } from '@/api/produit/produitReseau';
import { SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE } from '@/configuration/devisConf';
import * as allTypes from '../mutation-type';
import * as types from './planningReseauTempo-mutation-type';

function initialState() {
  return {
    produits: [],
    totalProduit: 0,
    datePlanning: {
      dateStart: moment([2019, 0, 1]),
      dateEnd: moment([2019, 0, 31]),
      days: 70,
    },
    brief: {
      auto: '',
      produitLocation: null,
      inclureConfreres: false,
      references: [],
      libelles: [],
      typeReseauIds: [],
      villes: [],
      agencesId: null,
      secteurIds: [],
    },
    panier: [],
    regroupementPersonnalise: false,
    afficherAnnonceur: true,
    typeDCF: null,
    useEcranAjout: false,
    boutonOption: false,
    boutonBloquer: false,
    boutonSelection: false,
    produitsLocation: [],
    produitsReseaux: [],
    produitReseau: null,
    afficherFacesAffectees: false,
  };
}

const namespaced = true;

const state = initialState();

const specAffichage = {
  widescreen: {
    size: 49,
  },
  tablet: {
    size: 35,
  },
};

const mutations = {
  [types.SET_PRODUITS](state, produits) {
    state.produits = produits;
  },
  [types.SET_PRODUITS_RESEAUX](state, produitsReseaux) {
    state.produitsReseaux = produitsReseaux;
  },
  [types.SET_PRODUIT_RESEAU](state, produitReseau) {
    state.produitReseau = produitReseau;
  },
  [types.SET_BRIEF](state, brief) {
    state.brief = brief;
  },
  [types.CLEAR_BRIEF](state) {
    state.brief = initialState().brief;
  },
  [types.CLEAR_PANIER](state) {
    state.panier = initialState().panier;
  },
  [types.CLEAR_BOUTONS](state) {
    state.boutonOption = initialState().boutonOption;
    state.boutonBloquer = initialState().boutonBloquer;
    state.boutonSelection = initialState().boutonSelection;
  },
  [types.SET_BOUTON_BLOQUER](state, ObjetBloquer) {
    state.boutonBloquer = ObjetBloquer.boutonBloquer;
    if (ObjetBloquer.boutonBloquer) {
      state.boutonOption = false;
      state.boutonSelection = false;
    } else if (!ObjetBloquer.isPlanning) state.boutonSelection = true;
  },
  [types.SET_BOUTON_OPTION](state, optionObjet) {
    state.boutonOption = optionObjet.boutonOption;
    if (optionObjet.boutonOption) {
      state.boutonBloquer = false;
      state.boutonSelection = false;
    } else if (!optionObjet.isPlanning) state.boutonSelection = true;
  },
  [types.SET_BOUTON_SELECTION](state, boutonSelection) {
    state.boutonSelection = boutonSelection;
    if (boutonSelection) {
      state.boutonBloquer = false;
      state.boutonOption = false;
    }
  },
  [types.ADD_LIGNE_IN_PANIER](state, ligne) {
    state.panier.push(ligne);
  },
  [types.SET_TOTAL_PRODUIT](state, totalProduit) {
    state.totalProduit = totalProduit;
  },
  [types.SET_AFFICHER_ANNONCEUR](state, afficherAnnonceur) {
    state.afficherAnnonceur = afficherAnnonceur;
  },
  [types.SET_AFFICHER_FACES_AFFECTEES](state, val) {
    state.afficherFacesAffectees = val;
  },
  [types.SET_PANIER](state, panier) {
    state.panier = panier;
  },
  [types.SET_TYPE_DCF](state, typeDCF) {
    state.typeDCF = typeDCF;
  },
  [types.SET_PRODUITS_LOCATION](state, produitsLocation) {
    state.produitsLocation = produitsLocation;
  },
  [types.DELETE_LIGNE_IN_PANIER](state, deleteObject) {
    if (deleteObject.isFromSelectScreen) {
      state.panier.splice(deleteObject.index, 1);
      return;
    }
    const panierWithLigneToDelete = state.panier.filter((ligne) => {
      return ligne.isFromDCF === deleteObject.isFromDCF;
    });
    panierWithLigneToDelete.splice(deleteObject.index, 1);
    const panierWithoutLigneToDelete = state.panier.filter((ligne) => {
      return ligne.isFromDCF === !deleteObject.isFromDCF;
    });
    const panier = panierWithLigneToDelete.concat(panierWithoutLigneToDelete);
    state.panier = panier;
  },
  [types.SET_USE_ECRAN_AJOUT](state, useEcranAjout) {
    state.useEcranAjout = useEcranAjout;
  },
  [types.SET_REGROUPEMENT_PERSONNALISE](state, regroupementPersonnalise) {
    state.regroupementPersonnalise = regroupementPersonnalise;
  },
  [types.SET_LOGO](state, item) {
    const produit = state.panier.find((ligne) => {
      return item.produitId === ligne.produitId && ligne.logo === undefined;
    });
    if (produit) produit.logo = item.logo ? item.logo : '';
  },
  [types.SET_DATE_PLANNING](state, datePlanning) {
    state.datePlanning = datePlanning;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadReseauTempo({ commit, dispatch }, data) {
    const listReseauTempo = (await getAllReseauTempo(data)).data.result;
    commit(types.SET_TOTAL_PRODUIT, listReseauTempo.totalCount);
    if (listReseauTempo.totalCount === 0) {
      commit(types.SET_PRODUITS, []);
    } else {
      await dispatch('getDisponibiliteByReseau', listReseauTempo.items);
    }
    return {};
  },
  async getDisponibiliteByReseau({ commit, getters }, listReseauTempo) {
    const arrayIdReseauTempo = listReseauTempo.map((reseauTempo) => {
      return reseauTempo.id;
    });
    if (arrayIdReseauTempo.length === 0) { return; }
    const dispoByReseau = (await getAllPlanning(
      arrayIdReseauTempo, getters.datePlanning.dateStart, getters.datePlanning.dateEnd,
    )).data.result;
    Object.keys(dispoByReseau).forEach((produit) => {
      dispoByReseau[produit].forEach((dispo) => {
        // On garde le stock prevu pour pourvoir l'utiliser lors de la creation de devis/commande
        dispo.nbFacePrevuStock = dispo.stock;
        dispo.annonceur = null;
      });
    });
    if (getters.afficherFacesAffectees) {
      await gestionFacesReelSurDispo(dispoByReseau, {
        produitIds: arrayIdReseauTempo,
        dateDebut: formatDate(getters.datePlanning.dateStart),
        dateFin: formatDate(getters.datePlanning.dateEnd),
      });
    }
    listReseauTempo.forEach(reseauTempo => {
      if (Object.prototype.hasOwnProperty.call(reseauTempo, 'dispo')) {
        reseauTempo.dispo.splice(0, reseauTempo.dispo.length);
        reseauTempo.dispo.push(...dispoByReseau[reseauTempo.id]);
      } else {
        reseauTempo.dispo = dispoByReseau[reseauTempo.id];
      }
    });
    await affectationReseauTempo(listReseauTempo);
    await commit(types.SET_PRODUITS, listReseauTempo);
  },
  async addLigneInPanier({ commit, getters, rootState }, data) {
    const ligne = await ajoutLignesCommandeProduitReseauTempoFromPlanningReseauTempo(
      data.produitReseauId, data.produitLocation, data.date, data.ligneReseau,
      null, getters.typeDCF,
    );
    if (data.isOption) ligne.etatSouhaite = OPTION;
    if (data.isBloquer) ligne.etatSouhaite = BLOQUE;
    // Si la ligne est ajouté a un avoir, la quantite dois etre négative.
    if (rootState.commande.commande?.sousType === SOUS_TYPE_AVOIR
      || rootState.commande.commande?.sousType === SOUS_TYPE_AVOIR_SUR_ACOMPTE
    ) {
      ligne.quantite *= -1;
      if (ligne.totalHt) ligne.totalHt = ligne.prixUnitaire * ligne.quantite;
      if (ligne.lignesCommande && Array.isArray(ligne.lignesCommande)) {
        ligne.lignesCommande.forEach(sousLigne => {
          sousLigne.quantite *= -1;
          if (sousLigne.totalHt) sousLigne.totalHt = sousLigne.prixUnitaire * sousLigne.quantite;
        });
      }
    }
    commit(types.ADD_LIGNE_IN_PANIER, ligne);
  },
  loadLogoPanier({ commit, getters }) {
    getters.panier.filter((produit) => {
      return produit.logo === undefined;
    })
      .forEach(async (produit) => {
        const logo = {
          produitId: produit.produitId,
          logo: await getLogo(produit.produitId),
        };
        commit(types.SET_LOGO, logo);
      });
  },
  async updateDatePlanning({ commit, getters }, newDatePlanning) {
    let breakpoint = 'tablet';
    if (window.innerWidth >= 1900) {
      breakpoint = 'widescreen';
    }
    newDatePlanning.days = specAffichage[breakpoint].size;
    newDatePlanning.dateEnd = newDatePlanning.dateStart.clone().add(newDatePlanning.days, 'd');
    if (getters.datePlanning.dateStart.isSame(newDatePlanning.dateStart, 'weeks')
      && getters.datePlanning.dateEnd.isSame(newDatePlanning.dateEnd, 'weeks')
      && getters.datePlanning.days === newDatePlanning.days) {
      return;
    }
    await commit(types.SET_DATE_PLANNING, newDatePlanning);
  },
  async loadReseau({ commit, getters }, data) {
    const findReseau = getters.produitsReseaux.find((produit) => {
      return produit.id === data.id;
    });
    if (findReseau) commit(types.SET_PRODUIT_RESEAU, findReseau);
    else {
      const reseauTempo = (await getReseau(data.id)).data.result;
      const reseaux = cloneDeep(getters.produitsReseaux);
      reseaux.push(reseauTempo);
      commit(types.SET_PRODUITS_RESEAUX, reseaux);
      commit(types.SET_PRODUIT_RESEAU, reseauTempo);
    }
  },
};

const getters = {
  produits: state => {
    return state.produits;
  },
  produitsReseaux: state => {
    return state.produitsReseaux;
  },
  produitReseau: state => {
    return state.produitReseau;
  },
  brief: state => {
    return state.brief;
  },
  panier: state => {
    return state.panier;
  },
  afficherAnnonceur: state => {
    return state.afficherAnnonceur;
  },
  afficherFacesAffectees: state => {
    return state.afficherFacesAffectees;
  },
  totalProduit: state => {
    return state.totalProduit;
  },
  datePlanning: state => {
    return state.datePlanning;
  },
  regroupementPersonnalise: state => {
    return state.regroupementPersonnalise;
  },
  typeDCF: state => {
    return state.typeDCF;
  },
  useEcranAjout: state => {
    return state.useEcranAjout;
  },
  boutonBloquer: state => {
    return state.boutonBloquer;
  },
  produitsLocation: state => {
    return state.produitsLocation;
  },
  boutonOption: state => {
    return state.boutonOption;
  },
  boutonSelection: state => {
    return state.boutonSelection;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
